import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { noop } from 'lodash';
import { SOCIAL_NETWORKS, shareMappingPath } from '../../../../../widget/constants/social-networks';
import { buildUrl, getOrigin, getBsi, openPopup } from '../../../../../common';
import { Tooltip } from '../../../../tooltip/tooltip';
import { InlineIcon } from '../../../../inline-icon/inline-icon';
import parentStyles from '../styles.scss';
import TwitterIcon from '../../../../../icons/compiled/components/TwitterIcon';
export class Twitter extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "onClick", () => {
      const {
        instanceInfo,
        videoId,
        channelId,
        descriptionText,
        canShareContent,
        content
      } = this.props;
      const {
        instanceId,
        componentId,
        sitePageId,
        siteUrl,
        biToken
      } = instanceInfo;
      const baseUrl = getOrigin(siteUrl);
      const shareProxyUrl = buildUrl(`${baseUrl}/${shareMappingPath}/${sitePageId}`, {
        'instance-id': instanceId,
        'component-id': componentId,
        'channel-id': channelId,
        'video-id': videoId,
        'bi-token': biToken,
        bsi: getBsi()
      });
      if (canShareContent) {
        const url = buildUrl('https://twitter.com/intent/tweet', {
          // eslint-disable-next-line
          original_referer: siteUrl,
          text: descriptionText.replace('{siteUrl}', shareProxyUrl).replace('{title}', content.title)
        });
        openPopup(url);
      }
      this.props.onShare(SOCIAL_NETWORKS.TWITTER);
    });
  }
  render() {
    const {
      className,
      dataHook,
      ariaLabel,
      tooltip
    } = this.props;
    return /*#__PURE__*/React.createElement(Tooltip, {
      content: tooltip
    }, /*#__PURE__*/React.createElement("button", {
      onClick: this.onClick,
      "data-hook": dataHook,
      className: className,
      "aria-label": ariaLabel
    }, /*#__PURE__*/React.createElement(InlineIcon, {
      icon: /*#__PURE__*/React.createElement(TwitterIcon, null),
      className: parentStyles.icon
    })));
  }
}
_defineProperty(Twitter, "defaultProps", {
  onShare: noop
});
//# sourceMappingURL=twitter.js.map